<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import MultiSelect from "vue-multiselect";
import { required, requiredIf } from "vuelidate/lib/validators";

// Custom Components
import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";
import BookingService from "@/helpers/APIService/booking.service";
import middlewares from "@/helpers/middlewares";

export default {
  data() {
    return {
      rfidEncoderOption: [],
      key_form: {
        rfid_encoder: null,
        rfid_card_id: null,
        key_type: "rfid",
        key_code: null,
        start_datetime: moment().format("YYYY-MM-DD HH:mm"),
        expire_datetime: moment().add(24, "hour").format("YYYY-MM-DD HH:mm"),
        is_deadbolt_enable: false,
        is_active: true,
        assigned_to: null,
        mobile: null,
        booking: null,
      },
      bookingOptions: [],
      bookingQuery: "",
      selectedRoomData: null,
      mobile_iso_code: 1,
      submitted: false,
      isBtnLoading: false,
      isGetResponseFromEncoder: false,
      isShowReadKeyDataCount: 15,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
  },
  components: {
    MultiSelect,
    DatePicker,
  },
  validations: {
    key_form: {
      start_datetime: { required },
      expire_datetime: { required },
      mobile: {
        required: requiredIf(function () {
          if (this.key_form.key_type === "mobile") {
            return true;
          }
        }),
      },
    },
  },
  mounted() {
    this.setValue();
  },
  methods: {
    // Method is used to set props value
    setValue() {
      if (this.currentProps.data) {
        let businessDate = moment().format("YYYY-MM-DD");
        if (localStorage.last_audit) {
          const date = localStorage.getItem("last_audit");
          businessDate = moment(date).format("YYYY-MM-DD");
        }
        if (this.selectedRoomData) {
          this.bookingQuery = `?and_allotted_room__room_number=${this.currentProps.data.device_id.room_number}&or_check_in_date__gte=${businessDate}&or_status=checked_in`;
          this.getBookingList(this.bookingQuery);
        }
      }
      this.selectedRoomData = this.currentProps.data;
      if (this.selectedRoomData.from == "booking") {
        this.key_form.mobile = this.selectedRoomData.device_id.mobile;
      }
      if (this.currentProps.isEdit) {
        this.setKeyData(this.currentProps.editData);
      }
      if (this.currentProps.rfidEncoderList) {
        if (this.currentProps.rfidEncoderList.length == 0) {
          this.key_form.key_type = "mobile";
          return middlewares.notification(
            "RFID encoder is not connected !!",
            "info",
            3000
          );
        }
        this.rfidEncoderOption = this.currentProps.rfidEncoderList;
        this.key_form.rfid_encoder = this.currentProps.rfidEncoderList[0];
        this.changeRFIDEncoder();
      } else {
        this.key_form.key_type = "mobile";
      }
    },
    // Method is used to set key data
    setKeyData(data) {
      this.key_form = {
        key_type: data.key_type,
        key_code: data.key_code,
        start_datetime: moment(data.start_datetime).format("YYYY-MM-DD HH:mm"),
        expire_datetime: moment(data.expire_datetime).format(
          "YYYY-MM-DD HH:mm"
        ),
        is_deadbolt_enable: data.is_deadbolt_enable,
        is_active: data.is_active,
        mobile: data.mobile,
      };
    },
    // Method is used to get booking list
    getBookingList(query) {
      BookingService.getBookingList(query)
        .then((response) => {
          if (response.results.length !== 0) {
            this.bookingOptions = response.results;
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to handle key type change
    changeKeyType(key_type) {
      this.key_form.key_type = key_type;
    },
    // Method is used to handle add new key
    handleSubmit(status, rfid_key) {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {};
        data = {
          key_type: this.key_form.key_type,
          user_levey_type: "guest",
          key_code: this.generateId(8),
          start_datetime: this.key_form.start_datetime,
          expire_datetime: this.key_form.expire_datetime,
          iot_device: this.selectedRoomData.device_id.lock_iot_device.id,
          room: this.selectedRoomData.device_id.id,
        };
        if (this.selectedRoomData.from == "booking") {
          data = {
            ...data,
            iot_device: this.selectedRoomData.device_id.lock_iot_device,
            booking: this.selectedRoomData.device_id.bookingId,
          };
        }
        if (this.key_form.key_type == "key_code") {
          this.createNewKey(data);
        }
        if (this.key_form.key_type == "rfid") {
          if (this.key_form.booking) {
            data = {
              ...data,
              booking: this.key_form.booking.id,
              rfid_card_id: rfid_key ? rfid_key.UID : "",
            };
          }
          this.key_form.rfid_encoder.connectionStr.send(
            JSON.stringify({
              cmd: "writecard",
              card_type: "Guest",
              startdate: moment(this.key_form.start_datetime).format(
                "DD/MM/YYYY hh:mm:ss"
              ),
              enddate: moment(this.key_form.expire_datetime).format(
                "DD/MM/YYYY hh:mm:ss"
              ),
              macrotech_id: `${this.selectedRoomData.device_id.lock_iot_device.config_data.master_data.macrotech_id}`,
              hotelId: `${this.selectedRoomData.device_id.lock_iot_device.config_data.master_data.hotel_id}`,
              guestkey: `${this.selectedRoomData.device_id.lock_iot_device.config_data.guest_key}`,
              roomno: `${this.selectedRoomData.device_id.lock_iot_device.config_data.master_data.room_number}`,
              floorno: `${this.selectedRoomData.device_id.lock_iot_device.config_data.master_data.floor}`,
              deadbolt: `${
                this.selectedRoomData.device_id.lock_iot_device.config_data
                  .deadbolt == false
                  ? 0
                  : 1
              }`,
            })
          );
          this.$bvModal.show("create-key-modal");
          const intervalId = setInterval(() => {
            if (this.isShowReadKeyDataCount == 0) {
              clearInterval(intervalId);
            } else {
              this.isShowReadKeyDataCount--;
            }
          }, 1000);
          if (status == "writecard") {
            this.isGetResponseFromEncoder = true;
            this.$bvModal.hide("create-key-modal");
            this.createNewKey(data);
          }
        }
        if (this.key_form.key_type == "mobile") {
          let mobileNo = this.removeNumberDecorations(this.key_form.mobile);
          mobileNo;
          if (mobileNo.charAt(0) !== this.mobile_iso_code) {
            mobileNo = this.mobile_iso_code + mobileNo;
          }
          data = {
            ...data,
            mobile: mobileNo,
          };
          this.createNewKey(data);
        }
      }
    },
    // Method is used to create new key
    createNewKey(data) {
      if (this.currentProps.isEdit) {
        UserService.updateNewKey(this.currentProps.editData.id, data)
          .then((response) => {
            this.$emit("submitted", response, true);
            this.isBtnLoading = false;
          })
          .catch((error) => {
            this.isBtnLoading = false;
            errorHandler(error);
          });
      } else {
        UserService.addNewKey(data)
          .then((response) => {
            this.$emit("submitted", response, false);
            this.isBtnLoading = false;
          })
          .catch((error) => {
            this.isBtnLoading = false;
            errorHandler(error);
          });
      }
    },
    // Method is used to remove number decorations
    removeNumberDecorations(mobile_number) {
      const mobile_number_copy = mobile_number.replaceAll(" ", "");
      let number = mobile_number_copy.replace(/[^a-zA-Z0-9 ]/g, "");
      return number;
    },
    // Method is used to handle country change
    countryChange(code) {
      this.mobile_iso_code = code.dialCode;
      // this.mobileNumberAdded();
    },
    // Method is used to get booking list based on mobile no
    mobileNumberAdded() {
      if (this.selectedRoomData && this.selectedRoomData.from == "booking") {
        return;
      }
      this.bookingOptions = [];
      if (this.key_form.mobile !== null && this.key_form.mobile !== "") {
        const mobileNo = this.removeNumberDecorations(this.key_form.mobile);
        this.bookingQuery.match(`?and_primary_guest__mobile=`, "");
        this.bookingQuery += `?and_primary_guest__mobile=${
          this.mobile_iso_code + mobileNo
        }`;
        this.getBookingList(this.bookingQuery);
      }
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
    },
    dec2hex(dec) {
      return dec.toString(16).padStart(2, "0");
    },
    // generateId :: Integer -> String
    generateId(len) {
      var arr = new Uint8Array((len || 40) / 2);
      window.crypto.getRandomValues(arr);
      return Array.from(arr, this.dec2hex).join("");
    },
    customLabel({ reference_no, primary_guest }) {
      return `${
        primary_guest.first_name + " " + primary_guest.last_name
      } - ${reference_no}`;
    },
    // Method is used to select booking
    selectedBooking() {
      if (this.key_form.booking !== null) {
        this.key_form.start_datetime = moment(
          this.key_form.booking.check_in_date +
            this.key_form.booking.check_in_time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm");
        this.key_form.expire_datetime = moment(
          this.key_form.booking.check_out_date +
            this.key_form.booking.check_out_time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm");
      }
    },
    // Method is used to handle change of RFID encoder
    changeRFIDEncoder() {
      let isCallAPI = 0;
      if (this.key_form.rfid_encoder !== null) {
        this.key_form.rfid_encoder.connectionStr.onmessage = (event) => {
          const encoderRes = JSON.parse(event.data);
          if (encoderRes.command == "writecard") {
            if (encoderRes.cmdstatus == "error") {
              return middlewares.notification(
                encoderRes.cmdmsg,
                "danger",
                3000
              );
            }
            if (encoderRes.cmdstatus == "success") {
              if (isCallAPI == 0) {
                this.handleSubmit("writecard", encoderRes.responsedata);
              }
              isCallAPI += 1;
            }
          }
        };
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div v-if="$route.path !== '/booking'">
      <h4>Add New Key</h4>
      <hr />
    </div>
    <div class="new-key-tab">
      <b-tabs pills justified content-class="pt-3 text-muted">
        <b-tab
          :active="key_form.key_type == 'rfid'"
          class="border-0"
          v-if="
            selectedRoomData !== null &&
            selectedRoomData.from !== 'booking' &&
            rfidEncoderOption.length !== 0
          "
          @click="changeKeyType('rfid')"
        >
          <template v-slot:title>
            <span class="d-inline-block" v-b-popover.hover.top="'top'">
              <img
                src="@/assets/images/rfid-key.png"
                alt="rfid-key"
                class="me-2"
              />
              <span class="d-none d-sm-inline-block">RFID</span>
            </span>
          </template>
          <div class="row">
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="rfid_encoder">
                <label for="rfid_encoder"> RFID Encoder </label>
                <MultiSelect
                  :options="rfidEncoderOption"
                  v-model="key_form.rfid_encoder"
                  :show-labels="false"
                  :allow-empty="false"
                  placeholder="Select RFID encoder"
                  track-by="id"
                  label="mqtt_user"
                  name="RFID Encoder list"
                  @close="changeRFIDEncoder"
                />
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="booking">
                <label for="booking"> Booking </label>
                <MultiSelect
                  :options="bookingOptions"
                  v-model="key_form.booking"
                  :show-labels="false"
                  :allow-empty="false"
                  placeholder="Select Booking List"
                  :custom-label="customLabel"
                  track-by="id"
                  name="RFID Encoder list"
                  @close="selectedBooking"
                  :showTimePanel="true"
                />
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="start_date">
                <label for="start_date">
                  Start Date Time<span class="text-danger">*</span>
                </label>
                <date-picker
                  v-model="key_form.start_datetime"
                  id="start-date"
                  format="YYYY-MM-DD HH:mm"
                  value-type="format"
                  type="datetime"
                  placeholder="YYYY-MM-DD HH:mm"
                  :clearable="false"
                  :class="{
                    'is-invalid':
                      submitted && $v.key_form.start_datetime.$error,
                  }"
                ></date-picker>
              </b-form-group>
              <div
                v-if="submitted && $v.key_form.start_datetime.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.key_form.start_datetime.required"
                  >Start Date is required.</span
                >
              </div>
            </div>
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="expire_datetime">
                <label for="expire_datetime">
                  Expire Date Time<span class="text-danger">*</span>
                </label>
                <date-picker
                  v-model="key_form.expire_datetime"
                  id="expire-date"
                  format="YYYY-MM-DD HH:mm"
                  value-type="format"
                  type="datetime"
                  placeholder="YYYY-MM-DD HH:mm"
                  :clearable="false"
                  :class="{
                    'is-invalid':
                      submitted && $v.key_form.expire_datetime.$error,
                  }"
                ></date-picker>
                <div
                  v-if="submitted && $v.key_form.expire_datetime.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.key_form.expire_datetime.required"
                    >Start Date is required.</span
                  >
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="is_active">
                <label for="is_active">Active</label>
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="is_active"
                    v-model="key_form.is_active"
                  />
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="is_deadbolt_enable">
                <label for="is_deadbolt_enable">DEADBOLT ENABLE</label>
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="is_deadbolt_enable"
                    v-model="key_form.is_deadbolt_enable"
                  />
                </div>
              </b-form-group>
            </div>
          </div>
        </b-tab>
        <b-tab
          @click="changeKeyType('mobile')"
          :active="key_form.key_type == 'mobile'"
        >
          <template v-slot:title>
            <span class="d-inline-block">
              <img
                src="@/assets/images/mobile-key.png"
                alt="mobile-key"
                class="me-2"
              />
              <span class="d-none d-sm-inline-block">Mobile</span>
            </span>
          </template>
          <div class="row">
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="start_date">
                <label for="start_date">
                  Start Date <span class="text-danger">*</span>
                </label>
                <date-picker
                  v-model="key_form.start_datetime"
                  id="start-date"
                  format="YYYY-MM-DD HH:mm"
                  value-type="format"
                  type="datetime"
                  placeholder="YYYY-MM-DD HH:mm"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="expire_datetime">
                <label for="expire_datetime">
                  Expire Date <span class="text-danger">*</span>
                </label>
                <date-picker
                  v-model="key_form.expire_datetime"
                  id="expire-date"
                  format="YYYY-MM-DD HH:mm"
                  value-type="format"
                  type="datetime"
                  placeholder="YYYY-MM-DD HH:mm"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </div>
            <div class="col-md-6 mb-3">
              <label for="mobile">Mobile </label>
              <vue-tel-input
                v-model="key_form.mobile"
                class="text-dark-gray"
                autoFormat
                :dropdownOptions="{
                  showDialCodeInList: true,
                  showDialCodeInSelection: true,
                  showFlags: true,
                  width: '390px',
                  showSearchBox: true,
                }"
                @country-changed="countryChange(...arguments)"
                :class="{
                  'is-invalid': submitted && $v.key_form.mobile.$error,
                }"
              >
                <!-- @blur="mobileNumberAdded" -->
              </vue-tel-input>
              <div
                v-if="submitted && $v.key_form.mobile.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.key_form.mobile.required"
                  >Mobile is required.</span
                >
              </div>
            </div>
            <!-- <div class="col-md-6">
              <b-form-group class="mb-3" label-for="booking">
                <label for="booking"> Booking </label>
                <MultiSelect
                  :options="bookingOptions"
                  v-model="key_form.booking"
                  :show-labels="false"
                  :allow-empty="false"
                  placeholder="Select Booking List"
                  :custom-label="customLabel"
                  track-by="id"
                  name="booking"
                  @close="selectedBooking"
                  :showTimePanel="true"
                />
              </b-form-group>
            </div> -->
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="is_active">
                <label for="is_active">Active</label>
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="is_active"
                    v-model="key_form.is_active"
                  />
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="is_deadbolt_enable">
                <label for="is_deadbolt_enable">DEADBOLT ENABLE</label>
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="is_deadbolt_enable"
                    v-model="key_form.is_deadbolt_enable"
                  />
                </div>
              </b-form-group>
            </div>
          </div>
        </b-tab>
        <b-tab
          @click="changeKeyType('key_code')"
          :active="key_form.key_type == 'key_code'"
        >
          <template v-slot:title>
            <span class="d-inline-block">
              <img
                src="@/assets/images/key-code.png"
                alt="key-code"
                class="me-2"
              />
              <span class="d-none d-sm-inline-block">Key Code</span>
            </span>
          </template>
          <div class="row">
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="start_date">
                <label for="start_date">
                  Start Date <span class="text-danger">*</span>
                </label>
                <date-picker
                  v-model="key_form.start_datetime"
                  id="start-date"
                  format="YYYY-MM-DD HH:mm"
                  value-type="format"
                  type="datetime"
                  placeholder="YYYY-MM-DD HH:mm"
                  :show-time-panel="true"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group class="mb-3" label-for="expire_datetime">
                <label for="expire_datetime">
                  Expire Date <span class="text-danger">*</span>
                </label>
                <date-picker
                  v-model="key_form.expire_datetime"
                  id="expire-date"
                  format="YYYY-MM-DD HH:mm"
                  value-type="format"
                  type="datetime"
                  placeholder="YYYY-MM-DD HH:mm"
                  :clearable="false"
                ></date-picker>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="is_active">
                <label for="is_active">Active</label>
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="is_active"
                    v-model="key_form.is_active"
                  />
                </div>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group class="mb-3" label-for="is_deadbolt_enable">
                <label for="is_deadbolt_enable">DEADBOLT ENABLE</label>
                <div class="form-check form-switch form-switch-md mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="is_deadbolt_enable"
                    v-model="key_form.is_deadbolt_enable"
                  />
                </div>
              </b-form-group>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <hr />
    <div class="col-md-12">
      <b-button
        class="float-end ms-2"
        variant="outline-primary"
        type="reset"
        @click="cancelSubmit"
        >Cancel</b-button
      >
      <b-button
        class="float-end ms-2"
        variant="outline-primary"
        @click="handleSubmit()"
        :class="{
          disabled: isBtnLoading,
        }"
      >
        <i
          class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          v-if="isBtnLoading"
        ></i>
        {{ currentProps.isEdit ? "Update Key" : "Create Key" }}
      </b-button>
    </div>
    <!-- Model is used to display RFID data -->
    <b-modal
      id="create-key-modal"
      title="Create new rfid key"
      centered
      hide-footer
    >
      <div v-if="isShowReadKeyDataCount !== 0">
        <img
          src="@/assets/images/rfid.gif"
          alt="rfid animation"
          class="w-75 text-center"
        />
        <h5 class="text-center">
          Pleace your card (<strong> {{ isShowReadKeyDataCount }}</strong> )
        </h5>
      </div>
      <div
        v-if="isGetResponseFromEncoder == false && isShowReadKeyDataCount == 0"
        class="text-center"
      >
        <img src="@/assets/images/canceled.gif" class="img-fluid" alt="" />
        <h6 class="mt-1">
          <span class="text-danger">We are not able to process</span>
        </h6>
        <p class="text-info">Please try again.</p>
      </div>
    </b-modal>
  </div>
</template>

<style>
.new-key-tab .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #238dfa;
  border: 2px solid #238dfa;
  background-color: transparent;
}
.new-key-tab .nav-pills .nav-link {
  padding: 16px;
  border: 2px solid rgb(246, 246, 246);
}
</style>
